import React, { useState, useMemo } from "react";
import { MimaTable } from "../../components";
import constant from "../../utils/constant";
import AuditController from "../../controllers/AuditController";
import moment from "moment";

const MimaAdminTable = ({ filterQuery }) => {
  const [limit, setLimit] = useState(50);

  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const adminAuditsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = AuditController.useGetAdminAudits(
    adminAuditsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const subscriptionDate = cell.row.original?.createdAt;
        return (
          <span>{moment(subscriptionDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },

    {
      Header: "User Name",
      Cell: ({ cell }) => {
        const firstName = cell.row.original.admin?.firstname || "";
        const lastName = cell.row.original.admin?.lastname || "";
        return <span>{`${firstName} ${lastName}`}</span>;
      },
    },
    {
      Header: "Email Address",
      accessor: "email",
      Cell: ({ cell }) => {
        const email = cell.row.original.admin?.email || "";
        return <span>{email}</span>;
      },
    },
    {
      Header: "Action performed",
      accessor: "activity",
    },
  ];

  return (
    <MimaTable
      tableData={tableData}
      tableColumns={tableColumns}
      searchPlaceholder="Search Admin Audit"
      searchVariant="wide"
      totalItems={data?.data?.totalCounts}
      onLimitChange={onLimitChange}
      isLoading={isLoading}
      isFetching={isFetching}
      limit={limit}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
    />
  );
};

export default MimaAdminTable;
